<script lang="ts">
import {ExpandingView, MutableWork, Work} from '../../model/model';
import {formatDate, formatKilometers} from '../../util/format';
import EntityTable from './EntityTable.vue';
import EditableInput from '../util/EditableInput.vue';
import ExpandingEntityTable from './ExpandingEntityTable.vue';
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    props: {
      works: Array<ExpandingView<Work>>,
      createdWork: {
          type: [MutableWork, null]
      },
      editEnabled: {
        type: Boolean
      }
    },
    data() {
      return {
        edited: null
      }
    },
    methods: {
      formatDate(date: String): String {
        return formatDate(date)
      },
      formatKilometers(kilometers: Number): String {
        return formatKilometers(kilometers)
      }
    },
    components: {FontAwesomeIcon, EntityTable, ExpandingEntityTable, EditableInput }
}
</script>

<template>
  <ExpandingEntityTable :entities="works" :cols="4"
    loading-message="work.load.inProgress" empty-message="work.load.empty" error-message="work.load.fail">
    <template #headers>
      <th>{{ $t("work.details.date") }}</th>
      <th>{{ $t("work.details.name") }}</th>
      <th>{{ $t("work.details.kms") }}</th>
      <th>{{ $t("work.details.components") }}</th>
    </template>
    <template #entity="work">
      <td>{{ formatDate(work.date) }}</td>
      <td>{{ work.name }}</td>
      <td>{{ formatKilometers(work.kilometers) }}</td>
      <td>{{ work.components.join(", ") }}</td>
    </template>
    <template #details="work">
      <table class="nested-table">
        <tr>
          <th>{{ $t("work.details.date") }}</th>
          <td data-field="date"><EditableInput v-model="work.date" :editable="editEnabled" type="date" /></td>
        </tr>
        <tr>
          <th>{{ $t("work.details.name") }}</th>
          <td data-field="name"><EditableInput v-model="work.name" :editable="editEnabled" raw-datalist="works-datalist" /></td>
        </tr>
        <tr>
          <th>{{ $t("work.details.kms") }}</th>
          <td data-field="kilometers"><EditableInput v-model="work.kilometers" :editable="editEnabled" type="int" /></td>
        </tr>
        <tr>
          <th>{{ $t("work.details.components") }}:</th>
          <td data-field="components">
            <ul v-if="!editEnabled">
              <li v-for="component in work.components">{{ component }}</li>
            </ul>
            <table v-if="editEnabled" class="editable-list">
              <tr v-for="(_,index) in work.components">
                <td><button @click="work.components.splice(index, 1);"  style="display: inline-block"><font-awesome-icon icon="minus-circle"/></button></td>
                <td><EditableInput v-model="work.components[index]" :editable="editEnabled" /></td>
              </tr>
              <tr>
                <td><button @click="work.components.push('');" style="display: inline-block"><font-awesome-icon icon="plus-circle"/></button></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <button v-if="editEnabled" class="work-button" @click="$emit('edit-work', work)"><font-awesome-icon class="nav-icon" icon="edit" /> {{ $t("work.update") }}</button>
      <button v-if="editEnabled" class="work-button" @click="$emit('delete-work', work.id)"><font-awesome-icon class="nav-icon" icon="trash" /> {{ $t("work.delete") }}</button>
    </template>
    <template #footer>
      <tr v-if="createdWork" id="new-row" class="data-row">
        <td data-field="date"><EditableInput v-model="createdWork.date" :editable="editEnabled" type="date" /></td>
        <td data-field="name"><EditableInput v-model="createdWork.name" :editable="editEnabled" type="string"  raw-datalist="works-datalist" /></td>
        <td data-field="kilometers"><EditableInput v-model="createdWork.kilometers" :editable="editEnabled" type="string" /></td>
        <td data-field="components"><EditableInput v-model="createdWork.components" :editable="editEnabled" type="array" /></td>
      </tr>
    </template>
  </ExpandingEntityTable>
</template>

<style scoped>
.work-button {
  padding: 1rem;
  margin: 0.5rem;
  cursor: pointer;
}

.nested-table .editable-list {
  padding-left: 0;
  min-width: 300px;
}

.nested-table ul {
  padding-left: 1rem;
}
</style>